(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["multi-variant-quick-buy-compact"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('multi-variant-quick-buy-compact')) {
    customElements.define(
      'multi-variant-quick-buy-compact',
      class MultiVariantQuickBuyCompact extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.form = this.querySelector('[data-quick-buy-form]');
          this.rows = Array.from(this.querySelectorAll('[data-variant-row]'));
          this.selectAll = this.querySelector('[data-select-all]');
          this.submitButton = this.querySelector('[data-submit]');
          this.summaryCount = this.querySelector('[data-summary-count]');
          this.selectionSummary = this.querySelector('[data-selection-summary]');
          this.footerSummary = this.querySelector('[data-footer-summary]');
          this.discountProgress = this.querySelector('[data-discount-progress]');
          this.errorMessage = this.querySelector('[data-error]');
          this.successMessage = this.querySelector('[data-success]');

          this.form?.addEventListener('submit', this.onSubmit.bind(this));
          this.selectAll?.addEventListener('change', this.onSelectAll.bind(this));
          this.rows.forEach((row) => {
            row.querySelector('[data-variant-checkbox]')?.addEventListener('change', () => this.updateState(true));
            row.querySelector('[data-quantity-minus]')?.addEventListener('click', () => this.changeQuantity(row, -1));
            row.querySelector('[data-quantity-plus]')?.addEventListener('click', () => this.changeQuantity(row, 1));
            row.querySelector('[data-quantity-input]')?.addEventListener('change', (event) => {
              this.normalizeQuantity(event.currentTarget);
              this.selectRow(row);
              this.updateState(true);
            });
          });
          const firstAvailableCheckbox = this.querySelector(
            '[data-variant-checkbox]:not(:disabled)'
          );

          if (firstAvailableCheckbox && this.selectedRows().length === 0) {
            firstAvailableCheckbox.checked = true;
          }
          
          this.updateState(false);
        }

        replaceCount(template, count) {
          return template.replace('[count]', String(count));
        }

        selectedRows() {
          return this.rows.filter((row) => row.querySelector('[data-variant-checkbox]')?.checked);
        }

        selectedQuantity() {
          return this.selectedRows().reduce((total, row) => {
            return total + Number(row.querySelector('[data-quantity-input]')?.value || 0);
          }, 0);
        }

        selectRow(row) {
          const checkbox = row.querySelector('[data-variant-checkbox]');
          if (checkbox && !checkbox.disabled) checkbox.checked = true;
        }

        normalizeQuantity(input) {
          const min = Number(input.min || 1);
          const max = input.max === '' ? Infinity : Number(input.max);
          const step = Number(input.step || 1);
          let value = Number(input.value || min);

          value = Math.max(min, Math.min(max, value));
          value = min + Math.round((value - min) / step) * step;
          input.value = String(Math.max(min, Math.min(max, value)));
        }

        changeQuantity(row, direction) {
          const input = row.querySelector('[data-quantity-input]');
          if (!input) return;

          this.normalizeQuantity(input);
          input.value = String(Number(input.value) + direction * Number(input.step || 1));
          this.normalizeQuantity(input);
          this.selectRow(row);
          this.updateState(true);
        }

        onSelectAll() {
          this.rows.forEach((row) => {
            const checkbox = row.querySelector('[data-variant-checkbox]');
            if (checkbox && !checkbox.disabled) checkbox.checked = this.selectAll.checked;
          });
          this.updateState(true);
        }

        updateState(clearMessages) {
          const selectedRows = this.selectedRows();
          const selectedQuantity = this.selectedQuantity();
          const availableCheckboxes = this.rows
            .map((row) => row.querySelector('[data-variant-checkbox]'))
            .filter((checkbox) => checkbox && !checkbox.disabled);

          this.rows.forEach((row) => {
            row.classList.toggle('is-selected', Boolean(row.querySelector('[data-variant-checkbox]')?.checked));
          });

          if (this.selectAll) {
            this.selectAll.checked = availableCheckboxes.length > 0 && availableCheckboxes.every((checkbox) => checkbox.checked);
            this.selectAll.indeterminate = availableCheckboxes.some((checkbox) => checkbox.checked) && !this.selectAll.checked;
          }

          const summaryTemplate = selectedQuantity === 1 ? this.dataset.selectedOne : this.dataset.selectedMany;
          const summary = this.replaceCount(summaryTemplate, selectedQuantity);
          if (this.summaryCount) this.summaryCount.textContent = String(selectedQuantity);
          if (this.selectionSummary) this.selectionSummary.textContent = summary;
          if (this.footerSummary) this.footerSummary.textContent = summary;
          if (this.submitButton) this.submitButton.disabled = selectedRows.length === 0;

          if (this.discountProgress && this.dataset.showDiscountProgress === 'true') {
            if (selectedQuantity >= 6) {
              this.discountProgress.textContent = this.dataset.discountFifteen;
            }
            else if (selectedQuantity >= 3) {
              this.discountProgress.textContent = this.dataset.discountTen;
            }
            else {
              this.discountProgress.textContent = this.replaceCount(this.dataset.discountNext, 3 - selectedQuantity);
            }
          }

          if (clearMessages) {
            this.hideMessage(this.errorMessage);
            this.hideMessage(this.successMessage);
          }
        }

        showMessage(element, message) {
          if (!element) return;
          element.textContent = message;
          element.hidden = false;
        }

        hideMessage(element) {
          if (!element) return;
          element.hidden = true;
          element.textContent = '';
        }

        async onSubmit(event) {
          event.preventDefault();
          if (this.submitButton?.getAttribute('aria-busy') === 'true') return;

          const items = this.selectedRows().map((row) => ({
            id: Number(row.querySelector('[data-variant-checkbox]').value),
            quantity: Number(row.querySelector('[data-quantity-input]').value)
          }));

          if (items.length === 0) {
            this.showMessage(this.errorMessage, this.dataset.noSelection);
            return;
          }

          if (document.body.classList.contains('template-cart') || window.theme?.settings?.cartType === 'page') {
            window.theme.utils.postLink2(window.theme.routes.cart_add_url, { parameters: { items } });
            return;
          }

          this.hideMessage(this.errorMessage);
          this.hideMessage(this.successMessage);
          this.submitButton.setAttribute('aria-busy', 'true');
          this.submitButton.setAttribute('aria-disabled', 'true');

          const sectionsToBundle = [];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:bundled-sections', {
              bubbles: true,
              detail: { sections: sectionsToBundle }
            })
          );

          try {
            const response = await fetch(window.theme.routes.cart_add_url, {
              ...window.theme.utils.fetchConfig('javascript'),
              body: JSON.stringify({
                items,
                sections: sectionsToBundle,
                sections_url: window.location.pathname
              })
            });
            const parsedState = await response.json();

            if (!response.ok || parsedState.status) {
              throw new Error(parsedState.description || parsedState.message || this.dataset.noSelection);
            }

            const cartResponse = await fetch(window.theme.routes.cart_url, window.theme.utils.fetchConfig('json', 'GET'));
            const cartJson = await cartResponse.json();
            cartJson.sections = parsedState.sections;

            window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              source: 'multi-variant-quick-buy-compact',
              cart: cartJson
            });
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));

            const addedQuantity = items.reduce((total, item) => total + item.quantity, 0);
            const successTemplate = addedQuantity === 1 ? this.dataset.successOne : this.dataset.successMany;
            this.resetSelection();
            this.updateState(false);
            this.showMessage(this.successMessage, this.replaceCount(successTemplate, addedQuantity));
            document.querySelector('cart-drawer')?.show(this.submitButton);
          }
          catch (error) {
            this.showMessage(this.errorMessage, error.message);
            document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: { errorMessage: error.message } }));
          }
          finally {
            this.submitButton.removeAttribute('aria-busy');
            this.submitButton.removeAttribute('aria-disabled');
            this.updateState(false);
          }
        }

        resetSelection() {
          this.rows.forEach((row) => {
            const checkbox = row.querySelector('[data-variant-checkbox]');
            const input = row.querySelector('[data-quantity-input]');
            if (checkbox) checkbox.checked = false;
            if (input) input.value = input.min || '1';
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
